module.exports = __webpack_public_path__ + "static/mastercard-059878cfec64fb11759846d2f52669f8.svg";